<template>
  <div class="dialog-bg" tabindex="0" @click.self="handleBackdropClick" @keydown.esc="handleEsc">
    <div class="dialog-box">
      <div class="title">
        {{ data.title || "Alert" }}
      </div>
      <div v-if="data.subTitle" class="subTitle text">
        {{ data.subTitle }}
      </div>
      <div v-if="data.remark" class="mark">
        <p v-if="data.remark && data.secondRemark" class="remark">
          * {{ data.remark }}<br>
          ** {{ data.secondRemark }}
        </p>
        <p v-else class="remark">
          * {{ data.remark }}
        </p>
      </div>
      <div v-if="hasDefaultSlot" class="detail">
        <slot></slot>
      </div>
      <div v-else-if="data.detail">
        <div v-if="!isHTML" class="detail text">
          {{ data.detail }}
        </div>
        <div v-else class="detail html">
          <div v-safe-html="data.detail"></div>
        </div>
      </div>
      <div v-if="!data.hideAction" class="button">
        <div class="row">
          <div v-if="data.buttonCancel" class="col p-0">
            <button
              :disabled="data.disableCancel"
              type="button"
              class="w-100 pointer"
              @click="onConfirm(false)"
            >
              {{ data.buttonCancel }}
            </button>
          </div>
          <div v-if="data.buttonSubmit" class="col p-0">
            <button
              id="confirm-btn"
              :disabled="data.disableSubmit"
              type="button"
              class="w-100 pointer text-danger"
              @click="onConfirm(true)"
            >
              {{ data.buttonSubmit }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    data: { type: Object, required: true },
    isHTML: { type: Boolean, default: false }
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    }
  },
  mounted() {
    this.$el.focus();
  },
  methods: {
    onConfirm(action) {
      this.$emit("confirm", action);
    },
    handleBackdropClick() {
      if (this.data.disableCancel) {
        return;
      }
      this.onConfirm(false);
    },
    handleEsc() {
      if (this.data.disableCancel) {
        return;
      }
      this.onConfirm(false);
    }
  }
};
</script>

<style scoped>
.dialog-box {
  padding: 0;
  border-radius: 15px;
  position: absolute;
  background-color: #fcfcfc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 290px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000;

  padding: 24px 40px;
}
.detail {
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000000;

  padding: 0 60px 15px;
}
.subTitle {
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000000;

  padding: 0 60px 15px;
}
button {
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: center;
  color: #212121;

  border: none;
  background-color: transparent;
  padding: 16px 0;
}
.button {
  margin-top: 16px;
  padding: 0 15px;
  border-top: 1px solid #e0e0e0;
}
.button > .row > div:nth-child(2) {
  border-left: 1px solid #e0e0e0;
}
.close {
  position: absolute;
  top: 10px;
  right: 15px;
  color: rgba(255, 255, 255, 1);
  z-index: 100;
}
.remark {
  font-size: 14px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
}
.mark {
  padding: 0px 60px;
}
</style>
